import {Dispatch} from "redux";

import {IFetchContext} from "@pg-mono/data-fetcher";
import {appendQueryString, catch400, getRequest} from "@pg-mono/request";
import {createRequestActionTypes} from "@pg-mono/request-state";
import {apiV2ListLink, Scenario} from "@pg-mono/rp-api-routes";

import {IRPRequestMeta} from "../../../app/rp_request_meta";
import {IPaginatedResponse} from "../../../request/IResponse";
import {getFetchOfferListPromotionalOffersCountQuery} from "../helpers/get_fetch_offer_list_query_data";
import {isPromotionsListingQuery} from "../helpers/map_offer_list_promotions_query_param";
import {ValidOfferListQuery} from "../helpers/validate_offer_list_query";

const OFFER_LIST_PROMOTIONAL_OFFERS_COUNT_PREFIX = "offer_list/LISTING_CONTEXT_PROMOTIONAL_OFFERS_COUNT";
export const fetchOfferListPromotionalOffersCountTypes = createRequestActionTypes(OFFER_LIST_PROMOTIONAL_OFFERS_COUNT_PREFIX);

const offerListLink = apiV2ListLink.offer.list(Scenario.OFFER_LIST);

export const fetchOfferListPromotionalOffersCount =
    (ctx: IFetchContext<IRPRequestMeta>, fullQuery: ValidOfferListQuery, routeQuery?: Record<string, string | string[] | null | boolean>) =>
    async (dispatch: Dispatch): Promise<number | null> => {
        if (routeQuery && isPromotionsListingQuery(routeQuery)) {
            return null;
        }

        dispatch({type: fetchOfferListPromotionalOffersCountTypes.start});

        const url = appendQueryString(offerListLink, {
            ...getFetchOfferListPromotionalOffersCountQuery(fullQuery),
            page: 1,
            page_size: 1
        });

        return getRequest(ctx.meta, url)
            .then((json: IPaginatedResponse) => {
                dispatch({type: fetchOfferListPromotionalOffersCountTypes.success, result: json.count});
                return json.count;
            })
            .catch(
                catch400(() => {
                    dispatch({type: fetchOfferListPromotionalOffersCountTypes.error});
                    return null;
                })
            );
    };
import {Dispatch} from "redux";

import {IFetchContext} from "@pg-mono/data-fetcher";
import {appendQueryString, catch400, getRequest} from "@pg-mono/request";
import {createRequestActionTypes} from "@pg-mono/request-state";
import {apiV2ListLink, Scenario} from "@pg-mono/rp-api-routes";

import {IRPRequestMeta} from "../../../app/rp_request_meta";
import {IPaginatedResponse} from "../../../request/IResponse";
import {getFetchOfferListPromotionalOffersCountQuery} from "../helpers/get_fetch_offer_list_query_data";
import {isPromotionsListingQuery} from "../helpers/map_offer_list_promotions_query_param";
import {ValidOfferListQuery} from "../helpers/validate_offer_list_query";

const OFFER_LIST_PROMOTIONAL_OFFERS_COUNT_PREFIX = "offer_list/LISTING_CONTEXT_PROMOTIONAL_OFFERS_COUNT";
export const fetchOfferListPromotionalOffersCountTypes = createRequestActionTypes(OFFER_LIST_PROMOTIONAL_OFFERS_COUNT_PREFIX);

const offerListLink = apiV2ListLink.offer.list(Scenario.OFFER_LIST);

export const fetchOfferListPromotionalOffersCount =
    (ctx: IFetchContext<IRPRequestMeta>, fullQuery: ValidOfferListQuery, routeQuery?: Record<string, string | string[] | null | boolean>) =>
    async (dispatch: Dispatch): Promise<number | null> => {
        if (routeQuery && isPromotionsListingQuery(routeQuery)) {
            return null;
        }

        dispatch({type: fetchOfferListPromotionalOffersCountTypes.start});

        const url = appendQueryString(offerListLink, {
            ...getFetchOfferListPromotionalOffersCountQuery(fullQuery),
            page: 1,
            page_size: 1
        });

        return getRequest(ctx.meta, url)
            .then((json: IPaginatedResponse) => {
                dispatch({type: fetchOfferListPromotionalOffersCountTypes.success, result: json.count});
                return json.count;
            })
            .catch(
                catch400(() => {
                    dispatch({type: fetchOfferListPromotionalOffersCountTypes.error});
                    return null;
                })
            );
    };
